import { Route, Routes } from "react-router-dom";
import { List } from "./List";

export default function DieuChinhNhieuHoaDon() {
  return (
    <Routes>
      <Route path="/" element={<List />} />
    </Routes>
  );
}
